<template>
  <div class="p-3">
    <h2 class="text-h6">Backup region</h2>
    <h3 class="h4 subtitle mb-4">Select what region you would like your sites backed up to.</h3>
    <p class="mb-4">Please note that you can also override this setting for individual sites.</p>
    <c-select
      style="width: 300px"
      :value="defaultValue"
      placeholder="Select region"
      :options="awsRegions"
      @update:value="handleRegionUpdate"
    >
      <template #append>
        <c-button color="primary" @click="setRegion">
          <c-spinner v-if="isSaving" color="success" size="sm" />
          <span v-else>Set region</span>
        </c-button>
        <!--        <CButton type="submit" color="primary" @click="setRegion">Set region</CButton>-->
      </template>
    </c-select>
  </div>
</template>

<script>
import _ from 'lodash';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'OrganisationBackup',
  props: {
    organisation: Object,
  },
  data() {
    return {
      newRegion: null,
      isSaving: false,
    };
  },
  computed: {
    defaultValue() {
      return _.get(this.organisation, 'config.backup.defaultS3Region');
    },
    awsRegions() {
      return this.$store.state.app.awsRegions.map((region) => ({
        value: region.region,
        label: region.name,
      }));
    },
  },
  methods: {
    handleRegionUpdate(data) {
      this.newRegion = data;
    },
    setRegion() {
      if (!this.newRegion) {
        return;
      }
      const data = {
        id: this.organisation._id,
        awsRegion: this.newRegion,
      };
      this.isSaving = true;
      this.$http
        .post(buildEndpoint('organisation-admin/organisation/backup/aws-region/update'), data)
        .then((response) => {
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Backup region updated.',
            });
            this.$store.commit('updateOrganisationBackupRegion', {
              awsRegion: this.newRegion,
            });
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>
